import { getChestApiUrl } from "../../helpers";
import { getHeaders } from '../helpers';
/**
 * Sends the booking to the api
 * @param {Object} data Booking data
 */
const book = (data) => {
  const { session, hotel, roomId, rateKey, check } = data;
  return new Promise((resolve, reject) => {
    return fetch(`${getChestApiUrl()}/chestApi/h/results`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        session,
        hotel,
        roomId,
        rateKey,
        check
      })
    })
      .then(r => r.json())
      .then(res => {
        if (!res.error) return resolve(res);
        else reject(res.error);
      })
      .catch(err => reject(err));
  });
}

export default {
  book
}